import { render, staticRenderFns } from "./ResendAwb.vue?vue&type=template&id=5c98593c&"
import script from "./ResendAwb.vue?vue&type=script&lang=js&"
export * from "./ResendAwb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports